import * as errorCodes from './../enums/error-codes'

let errorInfo = (type, error, errors) => {
  let errorCode = parseError(error)
  return getErrorInfo(type, errorCode, errors)
}

let parseError = (error) => {
  if (error.message) {
    return Number(error.message)
  } else if (error.status) {
    return Number(error.status)
  }
  return error
}

let getErrorInfo = (type, error, errors) => {
  let result = {}
  switch (error) {
    case 0:
      result.errorHeading = errors.heading.cantFindPage
      result.errorDescription = resolveErrorDescription(type, error, errors)
      result.errorCode = errorCodes.CP_101_ERROR
      result.showSearch = true
      break
    case 404:
      result.showSearch = true
      result.errorHeading = errors.heading.cantFindContent
      result.errorDescription = resolveErrorDescription(type, error, errors)
      result.errorCode = errorCodes.CP_102_ERROR
      break
    default:
      if (type === 'sharePreview') {
        result.showSearch = true
        result.errorHeading = errors.heading.cantFindContent
        result.errorDescription = resolveErrorDescription(type, error, errors)
        result.errorCode = errorCodes.CP_102_ERROR
      } else {
        result.showSearch = false
        result.errorHeading = errors.heading.cantLoadPage
        result.errorDescription = resolveErrorDescription(type, error, errors)
        result.errorCode = errorCodes.CP_301_ERROR
      }
  }
  return result
}

let resolveErrorDescription = (type, error, errors) => {
  return (type === 'sharePreview') ? getShareErrorDescription(error, errors) : getDefaultErrorDescription(error, errors)
}

let getShareErrorDescription = (error, errors) => {
  switch (error) {
    case 0:
      return errors.description.defaultError
    case 404:
      return {
        a: errors.description.error.a,
        b: errors.description.error.b
      }
    default:
      return {
        a: errors.description.error.a,
        b: errors.description.error.b
      }
  }
}

let getDefaultErrorDescription = (error, errors) => {
  switch (error) {
    case 0:
      return errors.default.description.defaultError
    case 404:
      return errors.default.description.addressError
    default:
      return {
        a: errors.default.description.default.a,
        b: errors.default.description.default.b
      }
  }
}
export default {
  errorInfo
}
